import { ValidatorFn } from '@angular/forms';

export interface ValidationMatrix {
  fieldName: string;
  elementType: ElementType;
  validators?: ValidatorFn | ValidatorFn[];
  validationDetails: {
    requiredDetail?: ValidationDetail;
    maxLengthDetail?: ValidationDetail;
    patternDetail?: ValidationDetail;
    notUniqueDetail?: ValidationDetail;
    leadingWhitespaceDetail?: ValidationDetail;
    negativeDecimalDetail?: ValidationDetail;
    limitExceededDetail?: ValidationDetail;
    decimalLimitDetail?: ValidationDetail;
    invalidEmailDetail?: ValidationDetail;
    futureStartDateDetail?: ValidationDetail;
    futureEndDateDetail?: ValidationDetail;
    incorrectDateRangeDetail?: ValidationDetail;
    minDateValidatorDetail?: ValidationDetail;
    emailMismatchDetail?: ValidationDetail;
  };
}

export interface ValidationDetail {
  fieldMessage: string;
  bannerMessage: string;
  maxLength?: number;
  minLength?: number;
  pattern?: RegExp;
}

export type ElementType = 'Input' | 'Radio' | 'Dropdown' | 'Other';
export const elementType = {
  Input: 'Input' as ElementType,
  Radio: 'Radio' as ElementType,
  Dropdown: 'Dropdown' as ElementType,
  Other: 'Other' as ElementType
};
